import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_account_conversion_hdr_RowClass} from '../../../dbschema';

export class ClaimAccountConversionContainerModel extends BaseContainerModel {
  bl_aat_claim_account_conversion_hdr: bl_aat_claim_account_conversion_hdr_RowClass = new bl_aat_claim_account_conversion_hdr_RowClass();
}
